import "core-js/modules/es.array.concat.js";
import defaultSettings from '@/settings';
var title = defaultSettings.title || '文化宫管理平台';
export default function getPageTitle(pageTitle, customTitle) {
  if (pageTitle && customTitle) {
    return "".concat(pageTitle, " - ").concat(customTitle);
  } else if (customTitle) {
    return "".concat(customTitle);
  } else if (pageTitle) {
    return "".concat(pageTitle, " - ").concat(title);
  }

  return "".concat(title);
}